import React, { useEffect, useState } from 'react';
import { readApiJson } from '../lib/api';

const REFRESH_MS = 5 * 60 * 1000;
// Coming back to the tab refreshes it, but not more than once a minute.
const MIN_GAP_MS = 60 * 1000;

// Wide enough for the badge to sit beside the logo in the header next to the
// full navigation, an admin's included, without squeezing it. Narrower, the
// dashboards show it under their heading.
export const ACTIVE_USERS_IN_HEADER_QUERY = '(min-width: 1360px)';

// How many accounts have been active since midnight Atlantic time: the
// admin dashboard's "Active today". The server leaves it out below five, so
// a quiet early morning shows nothing rather than "1 user active".
const ActiveUsersBadge = ({ className = '', compact = false }) => {
  const [count, setCount] = useState(null);

  useEffect(() => {
    let active = true;
    let loadedAt = 0;
    const load = () => {
      if (document.visibilityState === 'hidden' || Date.now() - loadedAt < MIN_GAP_MS) return;
      loadedAt = Date.now();
      readApiJson('/community/active-today')
        .then((data) => {
          if (active) setCount(Number.isFinite(data?.active_today) ? data.active_today : null);
        })
        .catch(() => {
          // Only a badge: a failed refresh keeps whatever it showed.
        });
    };
    load();
    const timer = window.setInterval(load, REFRESH_MS);
    document.addEventListener('visibilitychange', load);
    return () => {
      active = false;
      window.clearInterval(timer);
      document.removeEventListener('visibilitychange', load);
    };
  }, []);

  if (count === null) return null;

  return (
    <div
      className={`inline-flex shrink-0 items-center rounded-full border border-[#25384e] bg-[#091522]/80 font-semibold text-[#cfe2f5] ${
        compact ? 'gap-2 px-3 py-1 text-[11px]' : 'gap-2.5 px-3.5 py-1.5 text-xs'
      } ${className}`}
      data-testid="active-users-badge"
    >
      <span className={`relative flex ${compact ? 'h-2 w-2' : 'h-2.5 w-2.5'}`} aria-hidden="true">
        <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-[#67e0ae] opacity-60 motion-reduce:animate-none" />
        <span className="relative inline-flex h-full w-full rounded-full bg-[#67e0ae]" />
      </span>
      <span>
        <strong className="font-mono text-white">{count.toLocaleString()}</strong> users active
      </span>
    </div>
  );
};

export default ActiveUsersBadge;
